import { selectUserMarkets } from "../../state/selectors";
import { pushUsers } from "../../state/ducks";
import { dispatch, getState } from "../../state/store";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_API_URL;
const AMOUNT = 100;

const getRequestData = async (endpoint, attachQueryParams = false) => {
  let url = `${apiUrl}/user-management/${endpoint}`;

  if (attachQueryParams) {
    const allMarkets = selectUserMarkets()(getState());
    const { apps, markets } = getState().users.userFilters;

    const marketsFilter = !markets || markets.length === 0 ? allMarkets : markets;
    const marketQuery = (marketsFilter || []).join(",");

    url += `?market=${marketQuery}`;

    if (apps && apps.length > 0) {
      const appsQuery = apps.join(",");

      url += `&appType=${appsQuery}`;
    }
  }

  return url;
};

const fetchUsers = async (groupAssignments) => {
  const baseUrl = await getRequestData("get-users", true);
  const url = `${baseUrl}&amount=${AMOUNT}`;

  let hasToken = true;
  let tokenUrl = url;
  const data = [];

  while (hasToken) {
    const res = await fetchUsersBatch(tokenUrl);

    if (res?.users) {
      const filteredUsesrs = groupAssignments
        ? res.users.filter(
            (user) =>
              !groupAssignments ||
              groupAssignments.some(
                (assignment) => !assignment.isAdmin && assignment.email === user.email
              )
          )
        : res.users;

      data.push(...filteredUsesrs);
    }

    if (res?.nextToken) {
      tokenUrl = `${url}&nextToken=${res.nextToken}`;
    } else {
      hasToken = false;
    }
  }

  dispatch(pushUsers(data));
  return data;
};

const fetchUsersBatch = async (url) => {
  const data = await httpClient.get(url);

  return data?.data;
};

const fetchUser = async (email) => {
  const baseUrl = await getRequestData("get-user", true);
  const url = `${baseUrl}&email=${email}`;

  const data = await httpClient.get(url);

  return data?.data;
};

const createUser = async (user) => {
  const url = await getRequestData("create-user");

  return await httpClient.post(url, { data: user });
};

const updateUser = async (user) => {
  const url = await getRequestData("update-user");

  return await httpClient.put(url, { data: user });
};

const deleteUser = async (user) => {
  const url = await getRequestData("delete-user");

  return await httpClient.remove(url, { data: { email: user.email } });
};

const importUsersFile = async (file) => {
  const url = await getRequestData("create-users");

  return await httpClient.post(url, { data: file });
};

const resetUserPassword = async (email) => {
  const url = await getRequestData("reset-user-password");

  return await httpClient.put(url, { data: { email } });
};

const usersService = {
  fetchUsers,
  fetchUser,
  createUser,
  updateUser,
  deleteUser,
  importUsersFile,
  resetUserPassword
};

export default usersService;
